<div style="position: relative">
    <div *ngIf="state === loadingStates.LOADING && show">a</div>
    <div *ngIf="state === loadingStates.FAILURE && show">b</div>
    <div *ngIf="state === loadingStates.SUCCESS && show">c</div>
</div>
